import * as React from 'react';
import { Image, Pressable, StyleSheet, TextInput, View } from 'react-native';
import * as AppUtilities from "../context/AppUtilities";

const styles = StyleSheet.create({
  icon: { width: 24, height: 24, },
  icon2: { width: 18, height: 18, marginLeft: 5 },
  searchContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 10,
    paddingHorizontal: 10,
    borderWidth: 1,
    borderColor: "#cccccc",
    borderRadius: 5,
  },
  searchInput: {
    width: "100%",
    paddingVertical: 10,
    paddingLeft: 5,
  },
});

const HIT_SLOP = { top: 10, bottom: 10, left: 30, right: 5 };

export const SearchTextInput = React.forwardRef(
  function SearchTextInput(props, ref) {
    const [searchText, setSearchText] = React.useState("");
    const searchInputRef = React.useRef();

    React.useImperativeHandle(
      ref,
      () => {
        return {
          getText: () => searchText,
          setText: (text) => setSearchText(text),
        };
      },
      [searchText]
    );

    React.useEffect(() => {
      if (searchInputRef.current) {
        searchInputRef.current.focus();
      }
    }, [searchInputRef]);  

    return (
      <View style={styles.searchContainer}>
        <Pressable onPress={() => props.onBackPress ? props.onBackPress() : null} hitSlop={HIT_SLOP}>
          <Image
            source={require("../../assets/iphoneback2.png")}
            style={styles.icon}
          />
        </Pressable>
        <TextInput
          value={searchText}
          onChangeText={setSearchText}
          style={styles.searchInput}
          placeholder='Search'
          placeholderTextColor="#777777"
          {...props}
          ref={searchInputRef}
        />
        {
          !AppUtilities.isBlank(searchText) ?
              <Pressable onPress={() => setSearchText("")}>
                <Image
                  source={require("../../assets/clear-grey-18.png")}
                  style={styles.icon2}
                />
              </Pressable>
            :
              null
        }
      </View>
    );
  }
);
